import React from "react";
import "./PollHeader.css";
import defaultAvatar from "../assets/avatar.png"

export default function PollHeader({poll, showCount}) {
  let time_text;
  const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'EST' };
  time_text = new Date(poll.date_created).toLocaleDateString('en-US', options)

  let days_remaining;
  if (poll.isClosed && poll.date_closed) {
    let date_closed = new Intl.DateTimeFormat('en-US', { 
      month: 'short',
      day: 'numeric',
      year: 'numeric' 
    }).format(new Date(poll.date_closed));
    days_remaining = "Closed " + date_closed;
  } else {
    if (poll.days_remaining === 0) {
      days_remaining = "Closing soon";
    } else if (poll.days_remaining === 1) {
      days_remaining = "1 day left";
    } else {
      days_remaining = poll.days_remaining + " days left";
    }
  }

  return (
    <React.Fragment>
    <div style={{paddingBottom: "10px"}}>
      <div
        style={{backgroundImage: `url(${poll.author.avatarURL}), url(${defaultAvatar})`}}
        className="article-avatar"
      />
      <div className="profile-text-card" style={{marginTop: "3px"}}>
        <span className="author-name">
        { poll.author.fullname }<br/>
        </span>
        <span className="text-muted">
          { time_text }
        </span>
      </div>
      <div className="profile-text-card" style={{marginTop: "3px", float: 'right', fontWeight: '400', textAlign: 'right'}}>
        <span>
          {poll.votes} votes<br/>
        </span>
        <span>
          { days_remaining }
        </span>
      </div>
    </div>
    <h2 className="poll-card-title">
      {poll.title}
    </h2>
    </React.Fragment>
  );
}
